import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import moment from 'moment';
import { styleColumns } from '../ExportTemplateExcel/helperTemplateExcel';

const exportWorkbook = async (workbook: ExcelJS.Workbook, fileName: string) => {
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
    });
};

const createWorkbook = () => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Looyal';
    workbook.lastModifiedBy = 'Looyal';
    workbook.created = new Date();
    workbook.modified = new Date();
    return workbook;
};

const createWorksheet = (workbook: ExcelJS.Workbook, sheetName: string = 'Sheet1') => {
    let worksheet;
    worksheet = workbook.addWorksheet(sheetName);
    return worksheet;
};

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
) => {
    data.forEach((rowData, index) => {
        var row = worksheet.addRow(rowData);

        row.eachCell((cell, colIndex) => {
            cell.alignment = {
                vertical: 'top',
                wrapText: true,
                shrinkToFit: true,
            };

            if ([5, 8, 9, 10].includes(colIndex)) {
                cell.alignment.horizontal = 'right';
                cell.numFmt = (colIndex === 9 || colIndex === 10) ? typeof cell.value == 'number' && cell.value % 1 !== 0 ? '#,##0.00;-#,##0.00' : '#,##0;[Red]-#,##0' : '#,##0;[Red]-#,##0';
            } else if ([4, 6].includes(colIndex)) {
                cell.alignment.horizontal = 'center';
            }
        });
    });
};

const setColumnWidths = (worksheet: ExcelJS.Worksheet) => {
    const colWidths = [30, 30, 30, 25, 20, 25, 30, 15, 25, 25];
    worksheet.columns = colWidths.map((width) => ({ width }));
};

export const exportExcelReportProductsSold = async (
    nameFile: string,
    source: string,
    nameHeader: any,
    data?: any[],
) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook);

    var header = [...nameHeader.reportProductsSold.header]
    var subHeader = [...nameHeader.reportProductsSold.subHeader]

    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader

    if (!data) return console.error(`Data ${source} - Export is empty`);

    Array.from(data!).map((row, index) => {
        var temp_excel = [];
        temp_excel.push(
            row.templateName,
            row.PICName,
            row.merchantName,
            row.merchantCity || '',
            row.invoiceDate ? moment(row.invoiceDate).format('DD/MM/YYYY') : '',
            row.sku || '',
            row.name,
            row.qty,
            row.basePrice,
            row.totalPrice
        );
        exportData.push(temp_excel);
    });

    addDataRows(worksheet, exportData);
    setColumnWidths(worksheet);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);

    exportWorkbook(workbook, `${nameFile}.xlsx`);
};